import {Component} from '@angular/core';
import {TagBib} from "../../domain/models";
import {ActivatedRoute, Router} from "@angular/router";
import {OpenbandService} from "../../services/openband/openband.service";
import {NotificationService} from "../../services/notifications/notification.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Title} from "@angular/platform-browser";
import {PreferencesService} from "../../services/preferences/preferences.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-tag-bib',
  templateUrl: './tag-bib.component.html',
  styleUrls: ['./tag-bib.component.scss']
})
export class TagBibComponent {

  data: TagBib[] = [];
  sortedData: TagBib[] = [];
  eventId: string = "";
  tagBibForm: FormGroup;
  generateForm: FormGroup;
  sortField: string = 'bib';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: OpenbandService,
    private notifyService: NotificationService,
    private modalService: NgbModal,
    private titleService: Title,
    private prefs: PreferencesService,
    private fb: FormBuilder,
  ) {
    this.titleService.setTitle("Tag-Bib")
    this.initTagBibForm();
    this.initGenerateForm();
    route.params.subscribe(params => {
        this.parseRouteParams(params.id.toString())
        this.loadTagBibs()
      }
    )
  }

  initTagBibForm() {
    this.tagBibForm = this.fb.group({
      bib: ['', [Validators.required]],
      tag: ['', Validators.required]
    });
  }

  initGenerateForm() {
    this.generateForm = this.fb.group({
      ranges: ['', [Validators.required]],
      tagPrefix: ['', []],
      padding: [3, [Validators.required, Validators.min(1), Validators.max(10)]]
    });
  }

  openAddTagBibDialog(content: any) {
    this.tagBibForm.reset();
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title'
    });
  }

  openGenerateDialog(content: any) {
    this.generateForm.reset({
      padding: 3
    });
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title'
    });
  }

  parseBibNumbers(input: string): number[] {
    const numbers: number[] = [];
    // Сначала разбиваем по запятой, затем каждый элемент по пробелу
    const parts = input.split(',')
      .map(part => part.trim())
      .map(num => num.trim())
      .filter(num => num !== '');

    for (const part of parts) {
      const num = parseInt(part);
      if (!isNaN(num) && num >= 1 && num <= 9999) {
        numbers.push(num);
      }
    }

    return numbers;
  }

  onSubmitTagBib(modal: any) {
    if (this.tagBibForm.valid) {
      const bibNumbers = this.parseBibNumbers(this.tagBibForm.get('bib').value);
      const tag = this.tagBibForm.get('tag').value;

      if (bibNumbers.length === 0) {
        this.notifyService.showError('Введите корректные номера (от 1 до 9999)');
        return;
      }

      const tagBibs: TagBib[] = bibNumbers.map(bib => {
        const newTagBib = new TagBib();
        newTagBib.bib = bib.toString();
        newTagBib.tag = tag;
        return newTagBib;
      });

      this.api.uploadTagBib(this.eventId, tagBibs).subscribe(
        result => {
          this.loadTagBibs();
          this.notifyService.showSuccess(`Успешно добавлено ${tagBibs.length} Tag-Bib записей`);
          modal.close();
        },
        error => {
          this.notifyService.showError('Ошибка при добавлении Tag-Bib');
        }
      );
    }
  }

  sortBy(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.applySort();
  }

  private applySort() {
    this.sortedData = [...this.data].sort((a, b) => {
      let comparison = 0;

      if (this.sortField === 'bib') {
        comparison = +a.bib - +b.bib;
      } else if (this.sortField === 'updatedAt') {
        comparison = new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime();
      }

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
  }

  loadTagBibs() {
    this.api.getTagBibs(this.eventId).subscribe(
      result => {
        this.data = result;
        this.applySort();
      }
    )
  }

  getTimestamp(time: string): string {
    try {
      let parsed = new Date(time).toLocaleTimeString("ru-RU")
      if (parsed == "Invalid Date") return ""
      return parsed
    } catch (e) {
      return ""
    }
  }

  parseRouteParams(params: string) {
    var splitted = params.split(";")
    this.eventId = splitted[0];
  }

  uploadCsv($event) {
    try {
      const file: File = $event?.target?.files[0]
      if (file) {
        file.text().then(
          result => {
            let toUpload: TagBib[] = []
            let splitted = result.split("\n")
            let failed = false
            for (let index = 0; index < splitted.length - 1; index++) {
              let x = splitted[index]
              let resultStr = x.split(";")
              if (resultStr.length > 2) {
                failed = true
                break
              }
              if (resultStr.length < 2) resultStr = x.split("\t")

              let bib = resultStr[0]?.replace("\"", "")?.replace("\"", "")
              let tag = resultStr[1]?.replace("\"", "").replace("\"", "")
              if (bib == "" || isNaN(+bib)) {
                failed = true
                break
              }
              if (tag != null && bib != null) {
                let p = new TagBib();
                p.bib = bib
                p.tag = tag.replace("\r", "")
                toUpload.push(p)
              }
            }

            var fileInput = document.getElementById('upload-csv') as HTMLInputElement;
            fileInput.value = null
            if (failed) {
              this.notifyService.showError("Некорректный формат файла, прочитайте инструкцию чуть выше, please!")
              return
            }
            this.api.uploadTagBib(this.eventId, toUpload).subscribe(
              result => {
                this.loadTagBibs()
                this.notifyService.showSuccess(result.message)
              }
            )
          }
        )
      }
    } catch (ex) {

    }
  }

  private parseRanges(rangesStr: string): number[] {
    const numbers: number[] = [];
    const ranges = rangesStr.split(',').map(r => r.trim());

    for (const range of ranges) {
      if (range.includes('-')) {
        const [start, end] = range.split('-').map(n => parseInt(n.trim()));
        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = start; i <= end; i++) {
            numbers.push(i);
          }
        }
      } else {
        const num = parseInt(range);
        if (!isNaN(num)) {
          numbers.push(num);
        }
      }
    }

    return numbers.sort((a, b) => a - b);
  }

  private padNumber(num: number, padding: number): string {
    return num.toString().padStart(padding, '0');
  }

  onSubmitGenerate(modal: any) {
    if (this.generateForm.valid) {
      const {ranges, tagPrefix, padding} = this.generateForm.value;
      const numbers = this.parseRanges(ranges);

      if (numbers.length === 0) {
        this.notifyService.showError('Пожалуйста, введите корректные диапазоны номеров');
        return;
      }

      const tagBibs: TagBib[] = numbers.map(num => {
        const tagBib = new TagBib();
        tagBib.bib = num.toString();
        if (tagPrefix == null) {
          tagBib.tag = `${this.padNumber(num, padding)}`;
        } else {
          tagBib.tag = `${tagPrefix}${this.padNumber(num, padding)}`;
        }
        tagBib.eventId = this.eventId;
        return tagBib;
      });

      // Отправляем все tag-bib на сервер
      this.api.uploadTagBib(this.eventId, tagBibs).subscribe(
        () => {
          this.notifyService.showSuccess('Tag-Bib успешно сгенерированы');
          this.loadTagBibs();
          modal.dismiss();
        },
        error => {
          this.notifyService.showError('Ошибка при генерации Tag-Bib');
        }
      );
    }
  }

  clearTagBibs() {
    if (prompt("Подтвердите очистку, введя ID мероприятия") === this.eventId) {
      this.api.clearTagBib(this.eventId).subscribe(
        () => {
          this.notifyService.showSuccess('Tag-Bib успешно очищены');
          this.loadTagBibs();
        },
        error => {
          this.notifyService.showError('Ошибка при очистке tag-bib');
        }
      );
    } else {
      this.notifyService.showError("Некорректный ID")
    }
  }
}
